import React from 'react';
export function Transformation() {
  return <section className="py-10 px-4 bg-gray-900 text-white" data-id="element-163">
      <div className="max-w-5xl mx-auto" data-id="element-164">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-165">
          🔄 ANTES VS DESPUÉS
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-166">
          <div className="bg-red-500/10 border border-red-500/30 p-6 rounded-2xl" data-id="element-167">
            <h3 className="text-2xl font-bold text-red-400 mb-4 uppercase" data-id="element-168">
              ❌ ANTES
            </h3>
            <ul className="space-y-3" data-id="element-169">
              {['Noches interminables', 'Despertares constantes', 'Cansancio extremo', 'Frustración y dudas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-170">
                  <span className="text-red-500" data-id="element-171">✖</span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-green-500/10 border border-green-500/30 p-6 rounded-2xl relative overflow-hidden" data-id="element-172">
            <div className="absolute top-0 right-0 bg-green-500 text-black text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-173">
              TU META
            </div>
            <h3 className="text-2xl font-bold text-green-400 mb-4 uppercase" data-id="element-174">
              ✅ DESPUÉS
            </h3>
            <ul className="space-y-3" data-id="element-175">
              {['Bebé más regulado', 'Menos despertares', 'Siestas más largas', 'Más descanso y tranquilidad'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium" data-id="element-176">
                  <span className="text-green-500" data-id="element-177">✔</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-center text-gray-400 mt-8 text-xl font-medium" data-id="element-178">
          No perfección{' '}
          <span className="font-bold text-white" data-id="element-179">👉 Progreso real</span>
        </p>
      </div>
    </section>;
}